import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchConstraints } from './fetchConstraints'

type LinkConstraintPayload = {
  orderAttributeId: number
  vehicleAttributeId: number
  isCompatible: boolean
}

export const linkConstraint = createAsyncThunk('constraints/linkConstraint', async (payload: LinkConstraintPayload, { dispatch }) => {
  try {
    await OLMSApiService.post<void>('/constraint/link', payload)

    dispatch(setToast({
      open: true,
      severity: 'success',
      title: 'Link Constraint',
      content: 'Successfully linked constraints',
    }))

    // Refresh the constraints list
    await dispatch(fetchConstraints())

    return true
  } catch (error) {
    dispatch(setToast({
      open: true,
      severity: 'error',
      title: 'Link Constraint',
      content: 'Failed to link constraints',
    }))

    throw error
  }
})